module.exports = {"id":"214733","name":"Maximiliano Cerato","rating":"71","photo":"./data/images/photos/1/214733.png","club":{"name":"León","logo":"./data/images/clubs/Leon.png"},"positions":["AD","AG","BU"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MaximilianoCerato0.json
// module id = 2949
// module chunks = 0